import SingletonRouter from 'next/router';
import queryString from 'query-string';
import { useEffect } from 'react';

type SimpleLocation = {
  pathname: string;
  query?: Record<string, unknown>;
};
type Callback = (opts: {
  next: () => Promise<boolean>;
  prevLocation: SimpleLocation;
  nextLocation: SimpleLocation;
}) => Promise<boolean>;

/**
 * TODO:
 * * Handle back and forward browser navigation as well
 */
export const usePreventLocationChange = (callback: Callback) => {
  useEffect(() => {
    // @ts-expect-error This is not typed because is super low level apparently
    if (!SingletonRouter.router?.change) {
      return;
    }

    // @ts-expect-error This is not typed because is super low level apparently
    const originalChangeFunction = SingletonRouter.router.change;

    // @ts-expect-error This is not typed because is super low level apparently
    SingletonRouter.router.change = async (...args) => {
      const nextLocation = (() => {
        const href = args[2];
        const [pathname, search] = href.split('?');
        const query = search ? queryString.parse(search) : {};
        return {
          pathname,
          query,
        };
      })();

      const prevLocation = (() => {
        const { pathname, search } = window.location;
        const query = search ? queryString.parse(search) : {};
        return {
          pathname,
          query,
        };
      })();

      return callback({
        next: () => originalChangeFunction.apply(SingletonRouter.router, args),
        prevLocation,
        nextLocation,
      });
    };

    return () => {
      // @ts-expect-error This is not typed becuse is super low level apparently
      SingletonRouter.router.change = originalChangeFunction;
    };
  }, [callback]);
};
